import { AwardType, Bonus } from '../../../../types/bonus';
import { useContextualizedBonusDetails } from '../hooks/use-contextualized-bonus-details';

export const useSayThanks = (bonus: Bonus): boolean => {
	const { isUserReceiver } = useContextualizedBonusDetails(bonus);

	return isUserReceiver && bonus.award_type !== AwardType.Claimable;
};
